import { Box, Tab, Tabs } from "@mui/material";

const _sx = {
  "& .Mui-selected": {
    fontWeight: "500",
    color: "#000 !important",
    backgroundColor: "#fff !important",
    
  },
  "& button": {
    textTransform: "capitalize !important",
    paddingTop: "20px",
    paddingBottom : '15px',
    fontWeight: "400",
    fontFamily : 'Nunito Sans !important'
  },
  "& button:active": { border: "none !important" , outline : 'none !important'},
  "& .Mui-selected:active": { border: "none !important" , outline : 'none !important'},
  "& .Mui-selected:focus": { border: "none !important", outline : 'none !important' },
  "& .MuiTabs-indicator": {
    backgroundColor: "#6C5DD3", // This can be a color of your choice
    borderRadius : '24px  24px 0 0',
    height : '4px'
  },
  "& .MuiButtonBase-root .MuiTab-root" : {
    fontFamily : 'Nunito Sans !important'
  },
  "& .MuiTabs-scroller" : {
      overflowX : 'auto !important' 
  },

  "&::-webkit-scrollbar": {
   display : 'none !important' // Adjust as needed
  },
};

const TabStrip = (props) => {
  const { activeTab, onTabChange, data , allowedTabId, areTabsDisabled , margin ,padding = '0 40px'} = props;




  const isIdPresent = !!allowedTabId;
  
  return (
    <div id="tabstrip">
    <Box sx={{ borderBottom: 1, borderColor: "divider" , marginX : margin, overflowX: 'auto'}}>
      <Tabs value={activeTab} onChange={onTabChange} sx={_sx} style={{overflowX : 'auto', padding : padding}}>
        {data?.map((item) => {
          const isTabDisabled = areTabsDisabled && (allowedTabId !== undefined && item.id !== allowedTabId);
          // console.log('isdis', isTabDisabled)
          return <Tab key={item?.id} value={item?.label} label={item?.label} disabled={isTabDisabled} />;
        })}
      </Tabs>
    </Box>
    </div>
  );
  

};

export default TabStrip;
